import React from "react";

const Dry = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Kuru Temizleme
      </div>

      <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">İstanbul KURU TEMİZLEME HİZMETİ</h1>

      <div className="space-y-6">
        <p>
          İstanbul Temizlik Servisi olarak sunduğumuz kuru temizleme hizmetiyle kıyafetlerinizi, perde, mont, kaban ve benzeri özel eşyalarınızı profesyonel şekilde temizliyoruz. İstanbul genelinde hızlı, güvenilir ve hijyenik kuru temizleme çözümleri sunuyoruz.
        </p>

        <p>
          Kuru temizleme, özellikle su ile yıkanması uygun olmayan tekstil ürünleri için ideal bir yöntemdir. Kumaş yapısına zarar vermeyen özel kimyasallar kullanılarak lekeler çıkartılır, kumaş tazelenir ve ilk günkü gibi olur.
        </p>

        <p>
          Modern kuru temizleme makinelerimiz, çevreye ve sağlığa duyarlı temizlik solüsyonlarımız ve uzman personelimizle giysilerinize ve tekstil ürünlerinize özenle yaklaşırız. Yıkama, kurutma ve ütüleme süreçlerinin her biri titizlikle gerçekleştirilir.
        </p>

        <p>
          Ürünlerinizi adresinizden alıyor, işlem sonrası hijyenik ambalaj ile geri teslim ediyoruz. Tüm aşamalar kalite kontrolünden geçmektedir.
        </p>

        <p>
          İstanbul’da kuru temizleme hizmetinde kaliteyi arayanlar için 7/24 Whatsapp ve telefon desteğiyle buradayız. Randevunuzu hemen oluşturabilirsiniz.
        </p>

        <h2 className="text-xl font-bold text-[#003132]">👔 Kuru Temizleme Neleri Kapsar?</h2>
        <ul className="list-disc list-inside">
          <li>Takım elbise, ceket, pantolon, gömlek</li>
          <li>Abiye, gelinlik ve özel kumaşlar</li>
          <li>Mont, kaban, palto, deri ürünler</li>
          <li>Perde, tül, fon kumaşları</li>
          <li>Yorgan, battaniye ve büyük tekstil ürünleri</li>
        </ul>

        <h2 className="text-xl font-bold text-[#003132]">💧 Kuru Temizleme Sürecimiz</h2>
        <ol className="list-decimal list-inside space-y-2">
          <li>Ürün kabul ve etiketleme</li>
          <li>Kumaş analizi ve leke kontrolü</li>
          <li>Uygun kimyasal ile kuru temizleme</li>
          <li>Düşük ısıda kurutma ve havalandırma</li>
          <li>Ütüleme ve form verme işlemleri</li>
          <li>Son kalite kontrol ve ambalajlama</li>
          <li>Adresinize teslimat</li>
        </ol>

        <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
        <ul className="list-disc list-inside">
          <li>Kumaşa özel kuru temizleme solventleri</li>
          <li>Leke çıkarıcı ön işlem ürünleri</li>
          <li>Antibakteriyel ve parfümsüz solüsyonlar</li>
        </ul>

        <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
        <ul className="list-disc list-inside">
          <li>Her kumaşa özel kuru temizleme tekniği</li>
          <li>Deneyimli ve dikkatli personel</li>
          <li>Ücretsiz servis ve hızlı teslimat</li>
          <li>Hassas ürünler için garanti kapsamlı hizmet</li>
          <li>Uygun fiyat ve müşteri memnuniyeti odaklı yaklaşım</li>
        </ul>

        <p>
          Kıyafetlerinizi güvenle teslim edebileceğiniz, kaliteli kuru temizleme hizmeti için bizimle iletişime geçin. Şıklığınızı koruyun, biz temizleyelim!
        </p>
      </div>
    </div>
  );
};

export default Dry
